import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const getSubscribeError = (err) => {
  if (err.response?.status === 409) return { fn: toast.info, msg: "You're already on the list." };
  if (err.response?.status === 422) return { fn: toast.error, msg: 'Please enter a valid email address.' };
  return { fn: toast.error, msg: 'Something went wrong. Please try again.' };
};

const SubscribeForm = ({ email, setEmail, isSubscribing, onSubmit }) => (
  <form onSubmit={onSubmit} className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto">
    <input
      type="email"
      required
      placeholder="Enter your email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      className="flex-1 px-6 py-4 bg-black/50 border border-silver-900/50 rounded-lg text-white placeholder:text-white/40 focus:outline-none focus:border-silver-400 transition-colors"
      data-testid="subscribe-email-input"
    />
    <button
      type="submit"
      disabled={isSubscribing}
      className="px-8 py-4 bg-silver-400 hover:bg-silver-300 text-black font-bold text-sm uppercase tracking-wider rounded-lg transition-all duration-300 hover:scale-105 whitespace-nowrap disabled:opacity-50"
      data-testid="subscribe-submit-btn"
    >
      {isSubscribing ? 'Subscribing...' : 'Subscribe'}
    </button>
  </form>
);

export const JoinMovementSection = () => {
  const [email, setEmail] = useState('');
  const [isSubscribing, setIsSubscribing] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setIsSubscribing(true);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/subscribers`, { email: email.trim() });
      toast.success("You're in! Watch your inbox for new releases.");
      setEmail('');
    } catch (err) {
      const { fn, msg } = getSubscribeError(err);
      fn(msg);
    } finally {
      setIsSubscribing(false);
    }
  };

  return (
    <section className="py-20 px-6" data-testid="join-movement-section">
      <div className="container mx-auto">
        <div className="bg-gradient-to-r from-silver-900/20 to-transparent border border-silver-400/20 rounded-2xl p-12 md:p-16 text-center">
          <h2 className="text-4xl md:text-5xl font-black mb-6">
            <span className="text-white">Join the </span>
            <span className="text-silver-400">Movement</span>
          </h2>
          <p className="text-white/70 text-lg mb-8 max-w-2xl mx-auto">
            Be the first to hear new releases, get exclusive updates,
            and stay connected with the Rhodium Records family
          </p>
          <SubscribeForm
            email={email}
            setEmail={setEmail}
            isSubscribing={isSubscribing}
            onSubmit={handleSubscribe}
          />
        </div>
      </div>
    </section>
  );
};
